import _definePage_default_0 from '/vercel/path0/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/vercel/path0/src/pages/communication/history.vue?definePage&vue'
import _definePage_default_3 from '/vercel/path0/src/pages/communication/messages.vue?definePage&vue'
import _definePage_default_4 from '/vercel/path0/src/pages/communication/opinions.vue?definePage&vue'
import _definePage_default_5 from '/vercel/path0/src/pages/login.vue?definePage&vue'
import _definePage_default_6 from '/vercel/path0/src/pages/redirect.vue?definePage&vue'

export const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import('/vercel/path0/src/pages/index.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/vercel/path0/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/ambassador',
    name: 'ambassador',
    component: () => import('/vercel/path0/src/pages/ambassador.vue'),
    /* no children */
  },
  {
    path: '/beautyclub',
    name: 'beautyclub',
    component: () => import('/vercel/path0/src/pages/beautyclub.vue'),
    /* no children */
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('/vercel/path0/src/pages/calendar.vue'),
    /* no children */
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => import('/vercel/path0/src/pages/clients.vue'),
    /* no children */
  },
  {
    path: '/communication',
    /* internal name: 'communication' */
    /* no component */
    children: [
      {
        path: '',
        name: 'communication',
        component: () => import('/vercel/path0/src/pages/communication/index.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'history',
        name: 'communication-history',
        component: () => import('/vercel/path0/src/pages/communication/history.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
  _mergeRouteRecord(
      {
        path: 'messages',
        name: 'communication-messages',
        component: () => import('/vercel/path0/src/pages/communication/messages.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'opinions',
        name: 'communication-opinions',
        component: () => import('/vercel/path0/src/pages/communication/opinions.vue'),
        /* no children */
      },
  _definePage_default_4
  )
    ],
  },
  {
    path: '/financing',
    name: 'financing',
    component: () => import('/vercel/path0/src/pages/financing.vue'),
    /* no children */
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('/vercel/path0/src/pages/help.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/vercel/path0/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  _mergeRouteRecord(
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('/vercel/path0/src/pages/redirect.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  {
    path: '/statistics',
    /* internal name: 'statistics' */
    /* no component */
    children: [
      {
        path: '',
        name: 'statistics',
        component: () => import('/vercel/path0/src/pages/statistics/index.vue'),
        /* no children */
      },
      {
        path: 'checkout',
        name: 'statistics-checkout',
        component: () => import('/vercel/path0/src/pages/statistics/checkout.vue'),
        /* no children */
      },
      {
        path: 'clients',
        name: 'statistics-clients',
        component: () => import('/vercel/path0/src/pages/statistics/clients.vue'),
        /* no children */
      },
      {
        path: 'dac7',
        /* internal name: 'statistics-dac7' */
        /* no component */
        children: [
          {
            path: '',
            name: 'statistics-dac7',
            component: () => import('/vercel/path0/src/pages/statistics/dac7/index.vue'),
            /* no children */
          },
          {
            path: ':month',
            name: 'statistics-dac7-month',
            component: () => import('/vercel/path0/src/pages/statistics/dac7/[month].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'employeesActivity',
        name: 'statistics-employees-activity',
        component: () => import('/vercel/path0/src/pages/statistics/employeesActivity.vue'),
        /* no children */
      },
      {
        path: 'employeesCommissions',
        /* internal name: 'statistics-employees-commissions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'statistics-employees-commissions',
            component: () => import('/vercel/path0/src/pages/statistics/employeesCommissions/index.vue'),
            /* no children */
          },
          {
            path: ':ekey',
            name: 'statistics-employees-commissions-ekey',
            component: () => import('/vercel/path0/src/pages/statistics/employeesCommissions/[ekey].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'finances',
        name: 'statistics-finances',
        component: () => import('/vercel/path0/src/pages/statistics/finances.vue'),
        /* no children */
      },
      {
        path: 'sales',
        name: 'statistics-sales',
        component: () => import('/vercel/path0/src/pages/statistics/sales.vue'),
        /* no children */
      },
      {
        path: 'services',
        name: 'statistics-services',
        component: () => import('/vercel/path0/src/pages/statistics/services.vue'),
        /* no children */
      },
      {
        path: 'servicesCategories',
        name: 'statistics-services-categories',
        component: () => import('/vercel/path0/src/pages/statistics/servicesCategories.vue'),
        /* no children */
      },
      {
        path: 'servicesEmployee',
        /* internal name: 'statistics-services-employee' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'statistics-services-employee-id',
            component: () => import('/vercel/path0/src/pages/statistics/servicesEmployee/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'store',
        /* internal name: 'statistics-store' */
        /* no component */
        children: [
          {
            path: '',
            name: 'statistics-store',
            component: () => import('/vercel/path0/src/pages/statistics/store/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'visits',
        name: 'statistics-visits',
        component: () => import('/vercel/path0/src/pages/statistics/visits.vue'),
        /* no children */
      },
      {
        path: 'workTime',
        name: 'statistics-work-time',
        component: () => import('/vercel/path0/src/pages/statistics/workTime.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/storage',
    /* internal name: 'storage' */
    /* no component */
    children: [
      {
        path: '',
        name: 'storage',
        component: () => import('/vercel/path0/src/pages/storage/index.vue'),
        /* no children */
      },
      {
        path: 'import',
        /* internal name: 'storage-import' */
        /* no component */
        children: [
          {
            path: ':supplierId',
            name: 'storage-import-supplier-id',
            component: () => import('/vercel/path0/src/pages/storage/import/[supplierId].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'import-list',
        name: 'storage-import-list',
        component: () => import('/vercel/path0/src/pages/storage/import-list.vue'),
        /* no children */
      },
      {
        path: 'orders',
        /* internal name: 'storage-orders' */
        /* no component */
        children: [
          {
            path: '',
            name: 'storage-orders',
            component: () => import('/vercel/path0/src/pages/storage/orders/index.vue'),
            /* no children */
          },
          {
            path: ':orderId',
            name: 'storage-orders-order-id',
            component: () => import('/vercel/path0/src/pages/storage/orders/[orderId].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'product-list',
        name: 'storage-product-list',
        component: () => import('/vercel/path0/src/pages/storage/product-list.vue'),
        /* no children */
      },
      {
        path: 'stocktaking',
        /* internal name: 'storage-stocktaking' */
        /* no component */
        children: [
          {
            path: '',
            name: 'storage-stocktaking',
            component: () => import('/vercel/path0/src/pages/storage/stocktaking/index.vue'),
            /* no children */
          },
          {
            path: ':inventoryId',
            name: 'storage-stocktaking-inventory-id',
            component: () => import('/vercel/path0/src/pages/storage/stocktaking/[inventoryId].vue'),
            /* no children */
          },
          {
            path: 'summary',
            /* internal name: 'storage-stocktaking-summary' */
            /* no component */
            children: [
              {
                path: ':inventoryId',
                name: 'storage-stocktaking-summary-inventory-id',
                component: () => import('/vercel/path0/src/pages/storage/stocktaking/summary/[inventoryId].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'suppliers',
        name: 'storage-suppliers',
        component: () => import('/vercel/path0/src/pages/storage/suppliers.vue'),
        /* no children */
      },
      {
        path: 'transactions',
        /* internal name: 'storage-transactions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'storage-transactions',
            component: () => import('/vercel/path0/src/pages/storage/transactions/index.vue'),
            /* no children */
          },
          {
            path: ':transactionId',
            name: 'storage-transactions-transaction-id',
            component: () => import('/vercel/path0/src/pages/storage/transactions/[transactionId].vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]
